function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import HashMap from '../../../../java/util/HashMap';
import Coordinate from './Coordinate';
import Double from '../../../../java/lang/Double';
import Integer from '../../../../java/lang/Integer';
import Comparable from '../../../../java/lang/Comparable';
import Serializable from '../../../../java/io/Serializable';
var PrecisionModel = /*#__PURE__*/function () {
  function PrecisionModel() {
    _classCallCheck(this, PrecisionModel);
    PrecisionModel.constructor_.apply(this, arguments);
  }
  return _createClass(PrecisionModel, [{
    key: "equals",
    value: function equals(other) {
      if (!(other instanceof PrecisionModel)) {
        return false;
      }
      var otherPrecisionModel = other;
      return this._modelType === otherPrecisionModel._modelType && this._scale === otherPrecisionModel._scale;
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var other = o;
      var sigDigits = this.getMaximumSignificantDigits();
      var otherSigDigits = other.getMaximumSignificantDigits();
      return new Integer(sigDigits).compareTo(new Integer(otherSigDigits));
    }
  }, {
    key: "getScale",
    value: function getScale() {
      return this._scale;
    }
  }, {
    key: "isFloating",
    value: function isFloating() {
      return this._modelType === PrecisionModel.FLOATING || this._modelType === PrecisionModel.FLOATING_SINGLE;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._modelType;
    }
  }, {
    key: "toString",
    value: function toString() {
      var description = 'UNKNOWN';
      if (this._modelType === PrecisionModel.FLOATING) {
        description = 'Floating';
      } else if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
        description = 'Floating-Single';
      } else if (this._modelType === PrecisionModel.FIXED) {
        description = 'Fixed (Scale=' + this.getScale() + ')';
      }
      return description;
    }
  }, {
    key: "makePrecise",
    value: function makePrecise() {
      if (typeof arguments[0] === 'number') {
        var val = arguments[0];
        if (Double.isNaN(val)) return val;
        if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
          var floatSingleVal = val;
          return floatSingleVal;
        }
        if (this._modelType === PrecisionModel.FIXED) {
          return Math.round(val * this._scale) / this._scale;
        }
        return val;
      } else if (arguments[0] instanceof Coordinate) {
        var coord = arguments[0];
        if (this._modelType === PrecisionModel.FLOATING) return null;
        coord.x = this.makePrecise(coord.x);
        coord.y = this.makePrecise(coord.y);
      }
    }
  }, {
    key: "getMaximumSignificantDigits",
    value: function getMaximumSignificantDigits() {
      var maxSigDigits = 16;
      if (this._modelType === PrecisionModel.FLOATING) {
        maxSigDigits = 16;
      } else if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
        maxSigDigits = 6;
      } else if (this._modelType === PrecisionModel.FIXED) {
        maxSigDigits = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)));
      }
      return maxSigDigits;
    }
  }, {
    key: "setScale",
    value: function setScale(scale) {
      this._scale = Math.abs(scale);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PrecisionModel;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable, Comparable];
    }
  }], [{
    key: "mostPrecise",
    value: function mostPrecise(pm1, pm2) {
      if (pm1.compareTo(pm2) >= 0) return pm1;
      return pm2;
    }
  }]);
}();
export { PrecisionModel as default };
var Type = /*#__PURE__*/function () {
  function Type() {
    _classCallCheck(this, Type);
    Type.constructor_.apply(this, arguments);
  }
  return _createClass(Type, [{
    key: "readResolve",
    value: function readResolve() {
      return Type.nameToTypeMap.get(this._name);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._name;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Type;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable];
    }
  }]);
}();
Type.constructor_ = function () {
  this._name = null;
  var name = arguments[0];
  this._name = name;
  Type.nameToTypeMap.put(name, this);
};
Type.serialVersionUID = -5528602631731589822;
Type.nameToTypeMap = new HashMap();
PrecisionModel.Type = Type;
PrecisionModel.constructor_ = function () {
  this._modelType = null;
  this._scale = null;
  if (arguments.length === 0) {
    this._modelType = PrecisionModel.FLOATING;
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Type) {
      var modelType = arguments[0];
      this._modelType = modelType;
      if (modelType === PrecisionModel.FIXED) {
        this.setScale(1.0);
      }
    } else if (typeof arguments[0] === 'number') {
      var scale = arguments[0];
      this._modelType = PrecisionModel.FIXED;
      this.setScale(scale);
    } else if (arguments[0] instanceof PrecisionModel) {
      var pm = arguments[0];
      this._modelType = pm._modelType;
      this._scale = pm._scale;
    }
  }
};
PrecisionModel.serialVersionUID = 7777263578777803835;
PrecisionModel.FIXED = new Type('FIXED');
PrecisionModel.FLOATING = new Type('FLOATING');
PrecisionModel.FLOATING_SINGLE = new Type('FLOATING SINGLE');
PrecisionModel.maximumPreciseValue = 9007199254740992.0;